import * as React from 'react'

import { User } from '../../../../models/user'
import { EmploymentHistoryPositionForm } from './EmploymentHistoryPositionForm'

interface EmploymentHistoryAddPositionProps {
  user: User
}

export function EmploymentHistoryAddPosition({ user }: EmploymentHistoryAddPositionProps) {
  return <EmploymentHistoryPositionForm user={user} />
}
